const serviceRows = [
  {
    package: "全托管套餐",
    tier: "年出口 200 万",
    price: "22800",
    highlight: false,
    badge: "",
  },
  {
    package: "全托管套餐",
    tier: "年出口 300 万",
    price: "30800",
    highlight: false,
    badge: "",
  },
  {
    package: "全托管套餐",
    tier: "年出口 400 万",
    price: "38800",
    highlight: false,
    badge: "",
  },
  {
    package: "全托管套餐",
    tier: "年出口 500 万",
    price: "46800",
    highlight: true,
    badge: "最受欢迎",
  },
  {
    package: "半托管套餐",
    tier: "年出口 500 万",
    price: "32000",
    highlight: false,
    badge: "",
  },
];

const fullService =
  "含 1039 商户注册、备案、年维护费、制单报关、单证管理、物流咨询、出口代理、收结汇、注销等服务";
const halfService = "含 1039 商户注册、备案、年维护费、出口代理等服务";

export default function Pricing() {
  return (
    <section
      id="pricing"
      className="py-16 md:py-28 bg-background-50 relative overflow-hidden"
    >
      <div className="absolute top-20 right-0 w-[500px] h-[500px] bg-primary-500/5 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-20 left-0 w-[500px] h-[500px] bg-accent-500/5 rounded-full blur-3xl pointer-events-none" />

      <div className="relative z-10 max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-flex items-center gap-1.5 bg-background-100 border border-background-300/60 text-primary-700 text-sm font-medium px-4 py-1.5 rounded-full mb-5">
            市场采购贸易服务价格表 · 单位：元
          </span>
          <h2 className="text-[28px] md:text-[42px] font-heading font-extrabold text-foreground-900 mb-4 tracking-tight">
            服务与价格
          </h2>
          <p className="text-foreground-500 text-[15px] md:text-[17px] font-medium max-w-xl mx-auto">
            按年出口货值灵活选择，全托管一站式省心，半托管更轻量灵活
          </p>
        </div>

        {/* 移动端：卡片式价格表 */}
        <div className="md:hidden space-y-4">
          {serviceRows.map((row, i) => (
            <div
              key={i}
              className={`rounded-2xl border-2 p-5 ${
                row.highlight
                  ? "bg-accent-50/70 border-accent-200"
                  : "bg-background-50 border-background-200"
              }`}
            >
              <div className="flex items-center justify-between mb-2">
                <span className="text-[15px] font-bold text-foreground-900">
                  {row.package}
                </span>
                {row.badge && (
                  <span className="px-2.5 py-0.5 rounded-full bg-accent-500 text-background-50 text-[12px] font-bold whitespace-nowrap">
                    {row.badge}
                  </span>
                )}
              </div>
              <div className="text-[14px] font-medium text-foreground-700 mb-3">
                {row.tier}
              </div>
              <p className="text-[13px] text-foreground-500 leading-relaxed mb-4">
                {row.package === "全托管套餐" ? fullService : halfService}
              </p>
              <div className="flex items-center justify-between pt-4 border-t border-background-200">
                <span className="text-[13px] text-foreground-500">市场报价</span>
                <span
                  className={`text-[24px] font-heading font-extrabold tracking-tight tabular-nums ${
                    row.highlight ? "text-accent-600" : "text-primary-600"
                  }`}
                >
                  {row.price}
                  <span className="text-[13px] font-medium text-foreground-400 ml-1">
                    元
                  </span>
                </span>
              </div>
            </div>
          ))}

          <div className="border border-background-200 rounded-2xl px-5 py-4 bg-background-100/50">
            <p className="text-[13px] text-foreground-500 leading-relaxed">
              <i className="ri-information-line text-primary-500 mr-1.5" />
              以上报价为市场参考价，具体以实际业务场景与合同为准。
            </p>
          </div>
        </div>

        {/* 桌面端：表格 */}
        <div className="hidden md:block bg-background-50 border border-background-200 rounded-2xl overflow-hidden shadow-[0_4px_24px_-4px_rgba(0,0,0,0.05)]">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left py-5 px-8 text-[14px] font-bold text-foreground-800">
                  服务套餐
                </th>
                <th className="text-left py-5 px-8 text-[14px] font-bold text-foreground-800">
                  服务名称
                </th>
                <th className="text-left py-5 px-8 text-[14px] font-bold text-foreground-800">
                  服务内容
                </th>
                <th className="text-right py-5 px-8 text-[14px] font-bold text-foreground-800">
                  市场报价（元）
                </th>
              </tr>
            </thead>
            <tbody>
              {serviceRows.map((row, i) => (
                <tr
                  key={i}
                  className={`border-t border-background-200 transition-colors ${
                    row.highlight
                      ? "bg-accent-50/70"
                      : "hover:bg-background-100/60"
                  }`}
                >
                  <td className="py-5 px-8 align-top">
                    <div className="flex items-center gap-2">
                      <span className="text-[15px] font-bold text-foreground-900 whitespace-nowrap">
                        {row.package}
                      </span>
                      {row.badge && (
                        <span className="px-2.5 py-0.5 rounded-full bg-accent-500 text-background-50 text-[12px] font-bold whitespace-nowrap">
                          {row.badge}
                        </span>
                      )}
                    </div>
                  </td>
                  <td className="py-5 px-8 align-top">
                    <span className="text-[14px] font-medium text-foreground-700 whitespace-nowrap">
                      {row.tier}
                    </span>
                  </td>
                  <td className="py-5 px-8 align-top">
                    <span className="text-[14px] text-foreground-500 leading-relaxed block max-w-[380px]">
                      {row.package === "全托管套餐" ? fullService : halfService}
                    </span>
                  </td>
                  <td className="py-5 px-8 align-top text-right">
                    <span
                      className={`text-[26px] font-heading font-extrabold tracking-tight tabular-nums ${
                        row.highlight ? "text-accent-600" : "text-primary-600"
                      }`}
                    >
                      {row.price}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="border-t border-background-200 px-8 py-5 bg-background-100/50">
            <p className="text-[13px] text-foreground-500 leading-relaxed">
              <i className="ri-information-line text-primary-500 mr-1.5" />
              以上报价为市场参考价，具体以实际业务场景与合同为准；如需定制额度或收结汇服务，可咨询顾问获取专属方案。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}